// WHICH thread a drafted reply is being written on, and the offer to change it (busy-main-bff#25).
//
// Two rows, and they have to be the SAME two wherever the strip happens to be:
//
//   📧  Replying on Kitchen quote · you asked about “supplier”
//   🔗  Switch thread
//
// The first is the explanation the pick owes the user; the second is what makes it correctable.
// They belong together — a pick that can be seen but not corrected is only half an explanation —
// so they are built once, here, rather than by each briefing that has to show them.
//
// TWO briefings do. Asking "reply to the supplier" inside an Ongoing drafts on a thread the Brain
// chose and then NAVIGATES to `/emails/timeline/<id>?compose=reply`, which is a different screen
// with a different strip: the ongoing's briefing (lib/briefings/story.js) is not on it — the box is
// in email-creation mode by then, so the composer's own briefing (lib/briefings/creationFacts.js)
// owns the strip. The rows were only ever built by the story briefing, so at the exact moment the
// pick mattered — the composer open on a conversation nobody chose by hand — nothing said which
// thread it was, and "Switch thread", the one way back from a wrong pick, was not on screen at all.
//
// Hence a shared builder rather than a second copy: the two strips state the pick in one wording,
// with one glyph each and one action name, and cannot drift.
//
// Pure and shapeless — a plain array a briefing splices into its own rows — so what the pick SAYS
// is checkable without mounting either strip.

import { replyPickText, switchThreadOptions } from '@/lib/draftEvidence'

/** The action a "Switch thread" row names — resolved by SmartBox's `handleSuggestion`. */
export const SWITCH_THREAD_ACTION = 'switchReplyThread'

/**
 * The pick's rows, or an empty array when there is no pick to report.
 *
 * Empty is the everyday case: a reply started from the thread's own Reply chip decided nothing, so
 * there is nothing to justify and nothing to switch away from. An array (never null) so a caller can
 * always spread it into its own list without asking first.
 *
 * @param pick `ai/draftPick` — `{ subject, pickedWhy, alternatives }`, or null.
 */
export function replyPickRows(pick) {
  const text = replyPickText(pick)
  if (!text) return []
  const rows = [{ key: 'reply-pick', icon: 'email', text }]
  // The switch is offered only where there is somewhere to switch TO. A story with one thread had
  // no choice to get wrong, and a button that opens an empty chooser is worse than no button.
  if (switchThreadOptions(pick).length) {
    rows.push({ key: 'reply-switch', icon: 'link-connection', text: 'Switch thread', action: SWITCH_THREAD_ACTION })
  }
  return rows
}

export default replyPickRows
